import { render, staticRenderFns } from "./actionbar.vue?vue&type=template&id=887be18e"
import script from "./actionbar.vue?vue&type=script&lang=js"
export * from "./actionbar.vue?vue&type=script&lang=js"
import style0 from "./actionbar.vue?vue&type=style&index=0&id=887be18e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports